import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toastr } from 'react-redux-toastr';
import ErrorMessage from '../../components/text/ErrorMessage';
import api from '../../api';
import '../../styles/details.scss';
import '../../styles/settings.scss';

const AddRole: React.FunctionComponent<{
  onClose?: () => void;
  onCreateCompleted: () => void;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<{ name: string }>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onSubmit = async (data: { name: string }) => {
    try {
      await api.role.createRole({ ...data, permissions: [] });

      props.onCreateCompleted();

      toastr.success('Success', 'Role created successfully');
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error('Error', error?.response?.data?.data?.message.join());
      } else {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Add New Role</h5>
            </div>
          </div>
        </div>
        <div className="container-fluid px-0 h-100">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row no-gutters py-4 px-5">
              <div className="col-md-7 col-12">
                <div className="form-group font-weight-semibold mb-3">
                  <label htmlFor="" className="font-sm">
                    Role Name
                  </label>

                  <Controller
                    control={control}
                    rules={{ required: 'Role Name is required' }}
                    name="name"
                    render={({ onChange, value, name }) => (
                      <input
                        type="text"
                        className="form-control rounded-sm font-weight-semibold"
                        placeholder="Role Name"
                        name={name}
                        value={value}
                        onChange={onChange}
                        id="name"
                      />
                    )}
                  />

                  <ErrorMessage className="py-2">
                    {errors.name?.message}
                  </ErrorMessage>
                </div>
                <div className="form-group font-weight-semibold mb-3 text-right pt-3">
                  <button
                    type="button"
                    className="btn btn-outline-dark font-weight-semibold font-normal px-4 mr-1"
                    onClick={props.onClose}
                  >
                    <span className="px-3">Cancel</span>
                  </button>
                  <button className="btn btn-primary font-weight-semibold font-normal px-5">
                    <span className="px-3">Save</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddRole;
